module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Navbar"
    }
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": {
        name: "home"
      }
    }
  }, [_vm._v("Holidays")]), (_vm.admin && _vm.isAdmin) ? _c('span', [_vm._v("admin")]) : _vm._e()], 1), _c('div', {
    staticClass: "userMenu",
    class: {
      opened: _vm.showOptions
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showOptions = !_vm.showOptions
      }
    }
  }, [_c('a', {
    staticClass: "user"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.getMe.picture,
      "referrerpolicy": "no-referrer"
    }
  })]), _c('span', {
    staticClass: "content"
  }, [_vm._v("Hi, " + _vm._s(_vm.getMe.name))]), _c('span', {
    staticClass: "arrow"
  }, [_vm._v(" ")])]), (!_vm.admin && _vm.isAdmin) ? _c('router-link', {
    staticClass: "childrens admin",
    attrs: {
      "to": {
        name: "publicHolidays"
      }
    }
  }, [_c('span', {
    staticClass: "content"
  }, [_vm._v("Admin")])]) : _vm._e(), (_vm.admin && _vm.isAdmin) ? _c('router-link', {
    staticClass: "childrens calendar",
    attrs: {
      "to": {
        name: "home"
      }
    }
  }, [_c('span', {
    staticClass: "content calendar"
  }, [_vm._v("My Calendar")])]) : _vm._e(), _c('a', {
    staticClass: "childrens logout",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout()
      }
    }
  }, [_c('span', {
    staticClass: "content"
  }, [_vm._v("Log out")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-715ed6fb"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./src/components/Navbar/Navbar.pug
// module id = 186
// module chunks = 1